import axiosClient from "../../api/axiosClient";

const silentRequest = { __silentGenericToast: true };

export async function getProductGuidanceStates() {
  const response = await axiosClient.get(
    "/product-guidance/states",
    silentRequest
  );
  return Array.isArray(response?.data) ? response.data : [];
}

export async function updateProductGuidanceState({
  experienceType,
  experienceKey,
  version,
  status,
  currentStep,
}) {
  const path = [
    "/product-guidance/states",
    encodeURIComponent(experienceType),
    encodeURIComponent(experienceKey),
    version,
  ].join("/");
  const response = await axiosClient.put(
    path,
    { status, currentStep },
    silentRequest
  );
  return response?.data ?? null;
}

export async function consumeProductGuidanceForceReplay({
  experienceType,
  experienceKey,
  version,
}) {
  const path = [
    "/product-guidance/states",
    encodeURIComponent(experienceType),
    encodeURIComponent(experienceKey),
    version,
    "force-replay/consume",
  ].join("/");
  const response = await axiosClient.post(path, null, silentRequest);
  return response?.data ?? null;
}
